<template>
  <page-option :disable-add="!checkAccess('style.create')" overflow-hidden>
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E" size>mdi-format-font</v-icon>
      </v-avatar>
      <div class="pl-2 title-page"> {{ $t('sidebar.font.name') }}</div>
    </template>
    <template #below-toolbar>
      <FilterSearch
        canShowInSearch
        v-model="params"
        placeholder="Tìm kiếm theo tên"
        disable-create
        can-show-in-search
      >
        <v-spacer></v-spacer>
        <v-btn @click="onCreateFolder" text>
          <v-icon left dark size="25" text> mdi-folder-plus </v-icon>
          Tạo thư mục
        </v-btn>
      </FilterSearch>
    </template>
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="[]"
        :defaultParams="default_params"
        :params="parentParam"
        use-grid
        use-scroll-load
        use-top
      >
        <template #grid-item="{ item }">
          <FolderItem
            :value="item"
            @go-folder="goToFolderInfo"
            @delete-folder="onDeleteItem"
            @edit-folder="onUpdateItem"
          />
        </template>
      </base-serve-table>
    </v-sheet>
    <CreateFolderDialog ref="dialog" @reset="onReset" />
  </page-option>
</template>

<script>
import FilterSearch from '@layouts/filter-search.vue'
import { API_SYMBOL } from '@api'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
import CreateFolderDialog from '../components/create-folder-dialog.vue'
import FolderItem from '../components/folder-item.vue'
export default {
  mixins: [],
  components: {
    FilterSearch,
    CreateFolderDialog,
    FolderItem,
  },
  props: { option: { type: Object, default: () => ({ params: {} }) } },
  data: (vm) => ({
    workspace: {
      loading: false,
      items: [],
    },
    default_params: {},
    params: { search: '' },
    iconData: [],
    menus: [
      {
        type: 'update',
        handler: (item) => vm.onUpdateItem(item),
        disabled: (item) => !vm.checkAccess('style.update', item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !vm.checkAccess('style.delete', item),
      },
    ],
    loading: false,
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    api() {
      return { list: API_SYMBOL.getFolderItems }
    },
    parentParam() {
      let param = { ...this.params }
      param.type = 'font'
      return param
    },
  },
  mounted() {},
  methods: {
    onCreateFolder() {
      this.$refs.dialog.open({}, 'font-folder', EDIT_TYPE.CREATE)
    },
    onUpdateItem(item) {
      this.$refs.dialog.open(item, 'font-folder', EDIT_TYPE.UPDATE)
    },
    onReset() {
      this.$refs.table.reload()
    },
    async onDeleteItem(id) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await API_SYMBOL.deleteIcon(id)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    goToFolderInfo(id) {
      this.$router.push({ name: 'folderFont', params: { id } })
    },
  },
}
</script>
<style scoped>
.image-box {
  height: 120px;
  width: 120px;
  border: 1px solid #d4e6f1;
}
</style>
